module.exports = __webpack_public_path__ + "img/ken-min.934804c0.png";